module.exports = __webpack_public_path__ + "coin_GBP.svg?fc66a228dd861819299a16641e6d8fb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_GBP.svg
// module id = 1137
// module chunks = 2